import { isPresent } from 'utils/isPresent';
import { isBlank } from 'utils/isBlank';

export default class AuthorizationService {

    static isAuthorized(employee, permission) {
        if (isBlank(permission)) {
            return true;
        }

        if (false === AuthorizationService.isAdminUser(employee)) {
            return false;
        }

        if(Array.isArray(permission)) {
          return permission.some(p => employee.permissions.includes(p)) || employee.roles.includes('Founder')
        }

        return employee.permissions.includes(permission) || employee.roles.includes('Founder')
    }

    static isAdminUser(employee) {
        return isPresent(employee)
    }

    static isAuthorizedRole(employee, role) {
        if (isBlank(role)) {
            return true;
        }

        if (false === AuthorizationService.isAdminUser(employee)) {
            return false;
        }
        return employee.roles.includes(role) || employee.roles.includes('Founder')
    }
}
